'use client'

import { createContext, useContext } from 'react'
import invariant from 'tiny-invariant'

export const createRequiredContext = <T,>(name: string) => {
  const context = createContext<T | null>(null)

  const useRequiredContext = () => {
    const contextValue = useContext(context)

    invariant(contextValue, `use${name} must be used within a ${name}Provider`)

    return contextValue
  }

  return [useRequiredContext, context] as const
}
